(function () {
  var FREE_SHIPPING_CENTS = 4900; // 49 €

  var drawer, overlay, closeBtn, continueBtn, itemsEl, footerEl, totalEl, badge, shipText, shipFill;

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init() {
    drawer = document.getElementById('nn-cart-drawer');
    overlay = document.getElementById('nn-cart-overlay');
    closeBtn = document.getElementById('nn-cd-close');
    continueBtn = document.getElementById('nn-cd-continue');
    itemsEl = document.getElementById('nn-cd-items');
    footerEl = document.getElementById('nn-cd-footer');
    totalEl = document.getElementById('nn-cd-total');
    badge = document.getElementById('nn-cd-badge');
    shipText = document.getElementById('nn-cd-ship-text');
    shipFill = document.getElementById('nn-cd-ship-fill');

    if (!drawer) return;

    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    if (continueBtn) continueBtn.addEventListener('click', close);

    // Header cart icon → open drawer
    document.querySelectorAll('a.nn-icon-link[href*="cart"], a[href="/cart"]').forEach(function (a) {
      if (a.href && a.href.includes('checkout')) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    // Intercept ALL /cart/add form submits globally.
    // Use capture:true so we fire BEFORE Dawn's product-form.js handler,
    // then stopImmediatePropagation to prevent Dawn from also adding to cart.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (!form.action.includes('/cart/add')) return;
      e.preventDefault();
      e.stopImmediatePropagation();


      var fd = new FormData(form);
      var variantId = fd.get('id');
      var qty = parseInt(fd.get('quantity') || '1', 10);
      var props = {};
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = val;
      });

      var btn = form.querySelector('[type="submit"], button');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = '…'; btn.disabled = true; }

      NNCart.add(variantId, qty, props)
        .then(function () {
          if (btn) { btn.textContent = origText; btn.disabled = false; }
        })
        .catch(function () {
          if (btn) { btn.textContent = origText; btn.disabled = false; }
        });
    }, true); // capture:true → fires before Dawn's form-level handler
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('nn-open');
    overlay.classList.add('nn-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('nn-open');
    overlay.classList.remove('nn-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function updateShipping(total) {
    if (!shipText || !shipFill) return;
    var remaining = FREE_SHIPPING_CENTS - total;
    if (remaining <= 0) {
      shipText.innerHTML = 'Kostenloser Versand inklusive <strong>&#10003;</strong>';
      shipFill.style.width = '100%';
    } else {
      shipText.innerHTML = 'Noch <strong>' + fmt(remaining) + '</strong> bis kostenloser Versand';
      shipFill.style.width = Math.min(Math.round((total / FREE_SHIPPING_CENTS) * 100), 100) + '%';
    }
  }

  function updateHeaderDot(count) {
    var dot = document.getElementById('nn-header-cart-dot');
    if (dot) dot.style.display = count > 0 ? 'block' : 'none';
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'inline-flex' : 'none';
    }
  }

  function render(cart) {
    if (!itemsEl) return;
    updateShipping(cart.total_price);
    updateHeaderDot(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="nn-cd-empty">' +
        '<div class="nn-cd-empty-icon">&#9651;</div>' +
        '<p class="nn-cd-empty-text">Dein Warenkorb ist leer.</p>' +
        '</div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';
    if (totalEl) totalEl.textContent = fmt(cart.total_price);

    var html = '';
    cart.items.forEach(function (item) {
      var img = '';
      var imgSrc = (item.featured_image && item.featured_image.url) ? item.featured_image.url : item.image;
      if (imgSrc) {
        imgSrc = imgSrc.replace(/\?.*$/, '') + '?width=140';
        img = '<img src="' + imgSrc + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" class="nn-cd-item-img" loading="lazy">';
      }

      var props = '';
      if (item.properties) {
        Object.keys(item.properties).forEach(function (k) {
          var v = item.properties[k];
          if (v && k.charAt(0) !== '_') props += k + ': ' + v + ' ';
        });
      }

      html +=
        '<div class="nn-cd-item" data-key="' + item.key + '">' +
        img +
        '<div class="nn-cd-item-body">' +
        '<div class="nn-cd-item-name">' + item.product_title + '</div>' +
        (props ? '<div class="nn-cd-item-props">' + props.trim() + '</div>' : '') +
        '<div class="nn-cd-item-row">' +
        '<div class="nn-cd-qty">' +
        '<button class="nn-cd-qty-btn" data-action="minus" data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
        '<span class="nn-cd-qty-val">' + item.quantity + '</span>' +
        '<button class="nn-cd-qty-btn" data-action="plus" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
        '</div>' +
        '<div class="nn-cd-item-price">' + fmt(item.line_price) + '</div>' +
        '</div>' +
        '<button class="nn-cd-item-remove" data-key="' + item.key + '">Entfernen</button>' +
        '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;

    itemsEl.querySelectorAll('.nn-cd-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var newQty = this.dataset.action === 'plus'
          ? parseInt(this.dataset.qty, 10) + 1
          : Math.max(0, parseInt(this.dataset.qty, 10) - 1);
        changeQty(this.dataset.key, newQty);
      });
    });
    itemsEl.querySelectorAll('.nn-cd-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(this.dataset.key, 0); });
    });
  }

  function fetchAndRender() {
    if (!itemsEl) return;
    itemsEl.innerHTML = '<div class="nn-cd-loading"><div class="nn-cd-spinner"></div></div>';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {
        itemsEl.innerHTML = '<div class="nn-cd-empty"><p class="nn-cd-empty-text">Fehler beim Laden.</p></div>';
      });
  }

  function changeQty(key, qty) {
    // Snapshot keys currently in drawer before the change
    var keysBefore = {};
    if (itemsEl) {
      itemsEl.querySelectorAll('.nn-cd-item[data-key]').forEach(function (el) {
        keysBefore[el.dataset.key] = true;
      });
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Shopify may auto-add 0 € items (e.g. bundle triggers). Remove them immediately.
        var autoAdded = cart.items.filter(function (item) {
          return item.line_price === 0 && !keysBefore[item.key];
        });

        if (autoAdded.length === 0) {
          render(cart);
          return;
        }

        Promise.all(autoAdded.map(function (item) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 0 })
          });
        }))
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(console.error);
      })
      .catch(console.error);
  }

  window.NNCart = {
    open: open,
    close: close,
    add: function (variantId, qty, properties) {
      var body = { id: parseInt(variantId, 10), quantity: qty || 1 };
      if (properties && Object.keys(properties).length) body.properties = properties;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Fehler'); });
        return r.json();
      }).then(function () { open(); });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
